import {
	GRAY_COLORS,
	BRAND_COLORS,
	WARNING_COLORS,
	SUCCESS_COLORS,
	ERROR_COLORS,
	BLUE_GRAY_COLORS
} from '../globalTheme';
import { COLOR_TYPE } from '../globalTypes';

export function getCheckboxStyles() {
	return {
		container: {
			display: 'flex',
			alignItems: 'flex-start',
			gap: '8px',
			cursor: 'pointer'
		},
		textContainer: {
			display: 'flex',
			width: 'fit-content',
			cursor: 'pointer',
			flexDirection: 'column' as const,
			marginTop: '-3px'
		},
		fakeCheckboxContainer: {
			position: 'relative' as const,
			width: '18px',
			height: '18px',
			flexShrink: 0
		},
		fakeCheckbox: (_isFocused: boolean, type: COLOR_TYPE, checked: boolean, disabled: boolean) => ({
			position: 'absolute' as const,
			top: 0,
			left: 0,
			width: '100%',
			height: '100%',
			border: `1px solid ${disabled ? GRAY_COLORS.gray200 : getCheckboxBorderColor(type)}`,
			borderRadius: '4px',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			transition: 'all 0.2s',
			backgroundColor: disabled
				? GRAY_COLORS.gray100
				: checked
					? getCheckboxBackgroundColor(type)
					: 'transparent'
		}),
		realCheckbox: {
			appearance: 'none' as const,
			width: '100%',
			height: '100%',
			position: 'absolute' as const,
			top: 0,
			left: 0,
			opacity: 0,
			cursor: 'pointer'
		}
	};
}

function getCheckboxBorderColor(type: COLOR_TYPE): string {
	switch (type) {
		case 'warning':
			return WARNING_COLORS.warning400;
		case 'success':
			return SUCCESS_COLORS.success700;
		case 'error':
			return ERROR_COLORS.error700;
		case 'blueGray':
			return BLUE_GRAY_COLORS.blueGray700;
		case 'gray':
			return GRAY_COLORS.gray700;
		default:
			return BRAND_COLORS.brand700;
	}
}

function getCheckboxBackgroundColor(type: COLOR_TYPE): string {
	switch (type) {
		case 'warning':
			return WARNING_COLORS.warning100;
		case 'success':
			return SUCCESS_COLORS.success100;
		case 'error':
			return ERROR_COLORS.error100;
		case 'blueGray':
			return BLUE_GRAY_COLORS.blueGray100;
		case 'gray':
			return GRAY_COLORS.gray100;

		default:
			return BRAND_COLORS.brand50;
	}
}

export function getCheckboxLabelColor(type: COLOR_TYPE): string {
	switch (type) {
		case 'gray':
			return GRAY_COLORS.gray700;
		case 'blueGray':
			return BLUE_GRAY_COLORS.blueGray700;
		case 'success':
			return SUCCESS_COLORS.success700;
		case 'error':
			return ERROR_COLORS.error700;
		case 'warning':
			return WARNING_COLORS.warning300;
		default:
			return BRAND_COLORS.brand700;
	}
}
